<template>
    <div style="position: relative">
        <div style="position: absolute; right: 10px; top: 45px;">
            <slot name="overlay"></slot>
        </div>

        <c-column-header
            :label        = "title"
            class         = "primary white--text"
            :title-border = "true"
        >
            <template v-slot:pre>
                <div  class="audit-menu">
                    <c-audit-menu
                        :type        = "type"
                        :device-type = "deviceType"
                        :enums       = "auditEnums"
                        @category    = "onCategory"
                    />
                </div>
            </template>

            <template v-slot:toolbar>
                <slot name = "toolbar"></slot>
            </template>
        </c-column-header>

        <div class="bottom-border-radius pb-1" style="border-top-style: none; margin-top: 2px;">
            <div v-if="missingCatalogue" class="pa-4 error--text">
                {{ $t('audit.escalator.missingCatalogue') }}
            </div>

            <div
                v-if = "!missingCatalogue && category && category.id < 100"
            >
                <div class="v-flex pt-3">
                    <div style="width: 23%" class="pl-3">
                        <c-audit-index
                            v-if        = "category"
                            style       = "width: 80px"
                            :height     = "height"
                            orientation = "vertical"
                            :category   = "category.id"
                            :enums      = "auditEnums"
                            :data       = "entries"
                            :index      = "catalogueIndex"
                            @selected   = "onIndex"
                        />
                    </div>

                    <div
                        class  = "pl-2"
                        style  = "width: 65%; padding-right: 14px;"
                        :style = "'height: ' + height + 'px'"
                    >
                        <p-audit-catalog-entries
                            v-if              = "category && category.id < 100 && data"
                            :audit-id         = "data.id"
                            :entries          = "entries"
                            :show-header      = "false"
                            :type             = "type"
                            :device-type      = "deviceType"
                            :enums            = "auditEnums"
                            :unit             = "data.unit"
                            :show-budget-data = "showBudgetData"
                            :country          = "country"
                            @index            = "onScroll"
                            ref               = "entries"
                        />
                    </div>
                </div>
            </div>

            <p-audit-facilities
                v-if                   = "category && category.id === 100"
                :style                 = "'height: ' + (height+12) + 'px'"
                :facilities            = "data.facilities"
                :customer-measures     = "data['customerMeasure']"
                :manufacturer-measures = "data['manufacturerMeasure']"
            />

            <p-audit-hazards
                :style="'height: ' + (height+12) + 'px'"
                v-if = "category && category.id === 101"
                :show-title = "false"
                :hazards    = "data.hazards"
                :measures   = "data['hazardMeasure']"
            />
        </div>

        <slot name = "bottom"></slot>
    </div>
 </template>

<script>

import PAuditCatalogEntries from "@/modules/audit/components/private/PAuditCatalogEntries.vue";
import CAuditIndex          from "@/modules/audit/components/CAuditIndex.vue";
import PAuditFacilities     from "@/modules/audit/components/private/PAuditFacilities.vue";
import PAuditHazards        from "@/modules/audit/components/private/PAuditHazards.vue";
import CAuditMenu           from "@/modules/audit/components/CAuditMenu.vue";
import CColumnHeader        from "@/modules/core/components/utils/CColumnHeader.vue";
import AuditType, { ELEVATOR, ESCALATOR } from "@/modules/audit/service/AuditType";

export default {
    name: "CAuditOverview",

    components: {
        CColumnHeader,
        CAuditMenu,
        PAuditHazards,
        PAuditFacilities,
        CAuditIndex,
        PAuditCatalogEntries,
    },

    props: {
        data: {

        },

        country: {

        },

        height: {

        },

        type: {

        },

        /**
         * GBU type of the audit (HCIT-917): ELEVATOR or ESCALATOR. The catalogue set and the view of the entries depend
         * on it; `type` stays the area (GBU/ESG).
         */
        deviceType: {
            required: false,
            default : function () {
                return ELEVATOR;
            }
        },

        showBudgetData: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    computed: {
        isEscalator () {
            return this.deviceType === ESCALATOR;
        },

        auditEnums () {
            return AuditType.enums(this.$store.getters.audit, this.$store.getters.auditEscalator, this.deviceType);
        },

        /** An escalator GBU without the escalator catalogue would show elevator categories and no entries. */
        missingCatalogue () {
            return this.isEscalator && !this.$store.getters.auditEscalator;
        },

        title () {
            const type = this.type === "GBU" && this.data
                ? this.type + " · " + this.$t("audit.type." + this.deviceType)
                : this.type;

            return type + ' - ' + (this.category ? this.category.name : null);
        },

        hasData () {
            return this.data && this.data.entries && this.data.entries.length > 0;
        },

        categories () {
            return this.auditEnums.categories.filter(c => c.area === this.type);
        },

        catalogue () {
            return this.auditEnums.catalogue.filter(c => c.category.area === this.type);
        },

        entries () {
            if (!this.category) {
                return [];
            }

            if (!this.data || !this.data.entries) {
                return [];
            }

            return this.data.entries.filter (entry => entry.catalogue.category.id === this.category.id);
        },

        ratings () {
            return this.auditEnums.ratings;
        }
    },

    data: () =>({
        selected: [],
        category: null,
        refresh : 0,
        catalogueIndex: 0,
    }),

    methods: {
        onIndex (entry) {
            this.$refs.entries.scrollTo(entry)
        },

        onScroll (index) {
            this.catalogueIndex = index;
        },

        onCategory (category) {
            this.category = category;
            this.$emit("category", category)
        },
    }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

.audit-menu {
    margin-top: -2px;
    margin-right: 8px;
}

::v-deep .v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    line-height: 2.2;
}

</style>